import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails24 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery26.jpg";
    return (
        <>
         <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
            {/* <div className="body_wrap">
        <div className="page_wrap"> */}


            <Header />
            <div
                data-elementor-type="cpt_layouts"
                data-elementor-id="46"
                className="elementor elementor-46"
            >
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="52ebb12"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                    style={{ height: "30rem", marginBottom: "5rem" }}
                >
                    <div className="elementor-background-overlay"></div>
                    <div className="elementor-container elementor-column-gap-extended">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
                            data-id="ae9d67e"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-id="fcf91b3"
                                    data-element_type="section"
                                >
                                    <div className="elementor-container elementor-column-gap-extended">
                                        <div
                                            className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                                            data-id="93dfaf4"
                                            data-element_type="column"
                                        >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                                                    data-id="847c2c5"
                                                    data-element_type="widget"
                                                    data-widget_type="spacer.default"
                                                    style={{ height: "8rem" }}
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div className="elementor-spacer">
                                                            <div className="elementor-spacer-inner"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                                                    data-id="8fe49e3"
                                                    data-element_type="widget"
                                                    data-widget_type="trx_sc_layouts_title.default"
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div
                                                            id="trx_sc_layouts_title_515615674"
                                                            className="sc_layouts_title sc_align_center with_content without_image without_tint"
                                                        >
                                                            <div className="sc_layouts_title_content">
                                                                <div className="sc_layouts_title_title">
                                                                    {" "}
                                                                   
                                                                </div>
                                                                <div className="sc_layouts_title_breadcrumbs">
                                                                    <div className="breadcrumbs">
                                                                          
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



            <div className="page_content_wrap blog-details">
                <div className="content_wrap" >
                    <div className="content">
                        <div id="container" className="give-wrap container">
                            <div id="content" role="main">
                                <div
                                    id="give-form-288-content"
                                    className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                                >
                                    <div
                                        id="give-sidebar-left"
                                        className="give-sidebar give-single-form-sidebar-left"
                                    >
                                        <div className="images">
                                            <img
                                                width="1024"
                                                height="576"
                                                src={img1}
                                                className="attachment-large size-large wp-post-image blog-img"
                                                alt=""
                                                decoding="async"
                                                sizes="(max-width: 1024px) 100vw, 1024px"
                                            />
                                        </div>
                                    </div>
                                    <div className="summary entry-summary">
                                        <h2 itemProp="name" className="give-form-title entry-title">
                                            ડાલીબાઈની સમાધિ
                                        </h2>{" "}
                                        <div
                                            id="give-form-288-wrap"
                                            className="give-form-wrap give-display-onpage"
                                        >
                                            <div className="give-goal-progress">
                                                <div
                                                    className="raised blog-title"
                                                   
                                                >
                                                    <span className="income">ડાલીબાઈની સમાધિ

                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                id="give-form-content-288"
                                                className="give-form-content-wrap give_pre_form-content"
                                            >
                                                <p className="paragraph-content">
                                                    ડાલીબાઈ રણુંજાથી થોડેક દૂર ગાયોનું ધણ ચરાવતાં હતાં. તેમણે ઢોલનગારાંનો નાદ સાંભળ્યો. શો પ્રસંગ હશે ? એમ વિચારતાં હતાં, ત્યાં એ ગોવાળને જતો જોયો. તેને ડાલીબાઈએ પૂછ્યું, કે ભાઈ ! નોબતો ગડગડે છે ત દરબારમાં કંઈ પ્રસંગ છે કે શું ?’
                                                    ગોવાળે અચંબો પામતાં ડાલીબાઈને કહ્યું : ‘તમે દરબારમાં રહો છો તોય ખબ
                                                    નથી કે ?’
                                                    જી રે રામાસરોવરને ઘાટ, એ જી રે રામાસરોવરને ઘાટ, આજ માનવી મળ્યાં છે, ઘણાં ગામનાં...એ જી ...હોજી૰ જી રે કાને સંભળાણી વાત, એ જી રે કાને સંભળાણી વાત, આજ સમાધુ ખોદાયે, રામાપીરની... એ...જી ...હોજી. ખબર આપી ગોવાળ ચાલતો થયો. ડાલીબાઈ વાત સાંભળતાં આધાત લાગવાથી મૂર્છા ખાઈ ઢગલો થઈને પડ્યાં ! થોડી વારે મૂર્છા વળતાં એકદમ બેઠાં થઈ તેમણે ગાયોના ધણને એકઠું કર્યું. બધાંને પંપાળી વહાલ કરી નમન કર્યું. પછી પાસે જ એક ખેડૂત ખેતરમાં વાવણી કરી રહ્યો હતો. તેને કહેવા લાગ્યાં :
                                                    જીરે વીરા ખેતીના કરનાર; એ જી રે વીરા ખેતીના કરનાર, આજ વાછરું મારાં રે સંભાળજો.. એ જી...હોજી ખેડૂત બોલ્યો :
                                                    જી રે વાછરું સંભાળ્યાં નવ જાય, એ જી રે સંભાળ્યાં નવ જાય, આજ વાવણીએ સાચાં રે મોતી નીપજે એ જી ...હોજી ડાલીબાઈ ખેડૂતની વાતથી હતાશ થઈ ગયાં. ત્યાં તો તેણે ઘેટાં-બકરાં ચરાવતા ભરવાડને જોયો અને એને કાલાવાલા કરતાં કહ્યું :
                                                    જી રે રાયકા સાંભળ મારા વીર, એ જી રે સાંભળ મારા વીર, આજ વાછરું મારાં રે સંભાળજો ...એ જી ...હોજી

                                                </p>
                                                <p className="paragraph-content">
                                                    રાયકો બોલ્યો :
                                                    શ્રી રામદેવ રામાયણ
                                                    જી રે વાછરૂં સંભાળ્યાં નવ જાય, એ જી રે સંભાળ્યાં નવ જાય, આજ ઘેટાં ને બકરાં રે, કોણ સાચવે ? એ જી ...હોજી ‘બાઈ ! માંડ મારો માલ સચવાય છે, ત્યાં તારા માલને ક્યાં સાચવું? રાયકાના જવાબથી હતાશ થયેલી ડાલી ગાય- વાછરું પાસે આવી કહે લાગી : ‘હે ગાયમાતાઓ ! વહાલાં વાછરુંઓ ! આજ સુધી મેં તમારી મારાથી બનતી સેવા કરી. આજ મારા તમારા છેલ્લા મેળા છે, બાપુડિયાં ! ચરી ધરાઇ, સાંજે રામાસરોવરમાં જળ પી ગામમાં સૌ સૌને ઘેર જજો. તમારું રખેવાળું રામદેવનું છે, હું તો એમના આશરે મૂકીને જાઉં છું. એ મારો નાથ તમને રેઢા નહિ રાખે.' એમ કહી દોટ મૂકી દોડતી ‘રામાપીરની જય, રામાપીરની જય' એમ જયનાદ કરતી રામસરોવ૨ ઉપર આવી પહોંચી. તે જુએ છે તો રામસરોવર પર ભારે માનવમેદની હતી. સમાધિ ખોદવા માણસો જમીન ૫૨ કોશકોદાળીઓ મારતા હતા. તે દેખ ડાલીબાઈએ બૂમ મારીઃ ‘સબૂર ! ત્યાં ખોદશો નહિ !’ એમ બૂમ મારતી દોડતી આવી રામદેવજીના પગમાં પડી ગઈ. આ જોઈ ખોદનારા થંભી ગયા.
                                                    રામદેવજી બોલ્યા : ‘ડાલી ! તું ઘેલી નથી થઈ ને ?'
                                                    બે હાથ જોડી ડાલી બોલી : ના અન્નદાતા ! આ સ્થળ મારી સમાધિનું છે. આપ મારી સમાધિની જગાએ કેમ ખોદાવો છો ?'
                                                    ‘ડાલી, આ સ્થળ તારી સમાધિનું છે એની ખાતરી શી ?’
                                                    અન્નદાતા ! અહીં ખોદો અને જો આંટી, દોરો ને કાંસકી નીકળી તો આ સ્થળ મારી સમાધિનું અને પીતામ્બર ને ચાખડી નીકળે તો આપની સમાધિનું.' ‘ભલે !' એમ કહી રામદેવજીએ એ સ્થળે ખોદાવતાં આંટી, દોરો ને કાંસકી નીકળ્યાં.
                                                    સમાધિનો તૈયાર ખાડો ખોદેલો જોઈ રામદેવજી પ્રત્યે ડાલીબાઈ બોલી : ‘હૈ નાથ ! સાત સાત ભવથી હું આપની સાથે છું. આપના ચરણની દાસી છું; પછી હું પાછળ કેમ રહું ? આપને વધાવવા સામૈયું કરવા વહેલી જાઉં છું, મારા નાથ ! બોલો ‘શ્રી રામદેવપીરની જય'ની ઘોષણા કરી ડાલીબાઈએ સમાધિના ખાડામાં ઝંપલાવ્યું. પ્રભુના નામની છેલ્લી ઘોષણા કરી તેનો આત્મા દેહથી વિખૂટો પડી અમરાપુરમાં ગયો અને સમાધિ પુરાઈ ગઈ. ભાદરવા સુદી નોમને દિવસે
                                                    ડાલીબાઈએ સમાધિ લીધી.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>{" "}
                </div>
            </div>
            {/* </div>
      </div> */}
            <div>
                <Footer />
                {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
            </div>
        </>
    );
};

export default BlogDetails24;
